export const getBrowserTimeZone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';
  } catch (_error) {
    return 'UTC';
  }
};

export const buildDefaultProgrammeBranding = () => ({
  public_title: '',
  public_subtitle: '',
  guest_instructions: '',
  promotional_copy: '',
  theme_key: 'default',
});

export const buildDefaultEndCondition = () => ({
  mode: 'until_stopped',
  duration_minutes: 15,
  local_time: '23:00',
  time_zone: getBrowserTimeZone(),
});

export const normalizeSearchSuffix = (value, defaultValue) => (
  value == null ? defaultValue : String(value).trim().slice(0, 64)
);

export const normalizeProgrammeBranding = (value = {}) => {
  const raw = value && typeof value === 'object' ? value : {};
  const themeKey = String(raw.theme_key ?? raw.themeKey ?? 'default').trim().toLowerCase();
  return {
    public_title: String(raw.public_title ?? raw.publicTitle ?? '').trim().slice(0, 120),
    public_subtitle: String(raw.public_subtitle ?? raw.publicSubtitle ?? '').trim().slice(0, 180),
    guest_instructions: String(raw.guest_instructions ?? raw.guestInstructions ?? '').trim().slice(0, 240),
    promotional_copy: String(raw.promotional_copy ?? raw.promotionalCopy ?? '').trim().slice(0, 240),
    theme_key: ['default', 'neon', 'warm', 'sports', 'cinema'].includes(themeKey)
      ? themeKey
      : 'default',
  };
};

export const normalizeEndCondition = (value = {}) => {
  const raw = value && typeof value === 'object' ? value : {};
  const requestedMode = String(raw.mode || 'until_stopped').trim().toLowerCase();
  const duration = Number(raw.duration_minutes ?? raw.durationMinutes ?? 15);
  const localTime = String(raw.local_time ?? raw.localTime ?? '23:00').trim();
  return {
    mode: ['until_stopped', 'duration', 'local_time', 'before_next_programme'].includes(requestedMode)
      ? requestedMode
      : 'until_stopped',
    duration_minutes: Math.min(1440, Math.max(1, Number.isFinite(duration) ? Math.round(duration) : 15)),
    local_time: /^([01]\d|2[0-3]):[0-5]\d$/.test(localTime) ? localTime : '23:00',
    time_zone: String(raw.time_zone ?? raw.timeZone ?? getBrowserTimeZone()).trim() || 'UTC',
  };
};
